import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  BodyText,
  Box,
  Column,
  Heading,
  Row,
} from '@chargify/custom-ui-components';
import { NonProratedColumns, ProratedColumns } from './components/index';
import { ProductChangeStrategy } from '../../machines/changePlan/index';

type Props = {
  productName: string;
  basePlanPrice: string;
  productChangeStrategy: ProductChangeStrategy;
  existingBalance: string;
  billingEndDate: string;
  nextBillingAmount: string;
  proratedCreditAmount: string;
  currentProductName: string;
};
export const PlanChangeSummary = ({
  productName,
  basePlanPrice,
  productChangeStrategy,
  existingBalance,
  billingEndDate,
  nextBillingAmount,
  currentProductName,
  proratedCreditAmount,
}: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);
  const isProrated = productChangeStrategy === 'prorated';
  const isImmediate = productChangeStrategy === 'non-prorated';
  return (
    <>
      <Box marginBottom={6}>
        <BodyText variant={'body1'} color={'black.main'}>
          <Trans
            t={t}
            i18nKey={'plan_change.plan_change_from_to'}
            tOptions={{
              currentPlan: currentProductName,
              newPlan: productName,
            }}
          />
        </BodyText>
      </Box>
      <Box marginBottom={9}>
        <Row rowGap={8}>
          <Column span={24}>
            <Heading variant={'h4'}>
              {t('plan_change.plan_summary_title', { planName: productName })}
            </Heading>
          </Column>
          <Column span={12}>
            <BodyText variant={'body2'} color={'gray.dark'} fontWeight={600}>
              {t('plan_change.base_plan_price')}
            </BodyText>
          </Column>
          <Column span={12}>
            <BodyText
              textAlign={'right'}
              color={'success.main'}
              fontWeight={700}
            >
              {basePlanPrice}
            </BodyText>
          </Column>
          {isProrated ? (
            <ProratedColumns
              productName={productName}
              billingEndDate={billingEndDate}
              proratedCreditAmount={proratedCreditAmount}
            />
          ) : (
            <NonProratedColumns
              isImmediate={isImmediate}
              nextBillingAmount={nextBillingAmount}
              billingEndDate={billingEndDate}
              existingBalance={existingBalance}
              productName={productName}
            />
          )}
        </Row>
      </Box>
    </>
  );
};
